import styled from 'styled-components';
import { grid, GridProps } from 'styled-system';

export const Container = styled.div<GridProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
  ${grid};
`;
